export default {"src":"/_next/static/media/star-completed.0ca4cf02.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};